import { RootState } from 'state/global-state';

export const selectCartEntries = ({ ordering }: RootState) => ordering.cart.cartEntries;
